export default __webpack_public_path__ + "static/media/people.d042c149.svg";